<script>
import Multiselect from "vue-multiselect";

export default {
  components:{
    Multiselect
  },
  props: {
    currentEmpresa: { type: Object },
    listCodeTax: { type: Array },
    oldSpecialty: { type: Object },
    },
  data() {
    return {
      Specialty: {},
    }
  },
  created(){
    this.Specialty = this.oldSpecialty
  },
  mounted() {
    this.$emit('newTitle', 'Alterar Tratamento')
  },
  methods: {
    setPut() {
      let speciality = {
        id: this.Specialty.id,
        name: this.Specialty.name,
        code_tax_id: this.Specialty.code_tax.id,
        empresa_id: this.currentEmpresa.id,
      }
      this.$emit('doPut', speciality)
    },
  },
}
</script>

<template>
<div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <Label>{{ "Nome" }}</Label>
          <input v-model="Specialty.name" type="text" class="form-control text-left">
        </div>
        <div class="col-md-12">
          <Label>* Código Fiscal:</Label>
          <Multiselect
            v-model="Specialty.code_tax"
            :options="listCodeTax"
            :multiple="false"
            :taggable="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :selectLabel="''"
            :deselectLabel="''"
            :deselectAllLabel="''"
            :placeholder="'Selecione o Código Fiscal'"
            track-by="id"
          >
            <!-- Para a opção selecionada -->
            <template slot="singleLabel" slot-scope="props">
              <strong>{{ props.option.id }}</strong> - {{ props.option.name }}
            </template>
            <!-- Para as opções da lista -->
            <template slot="option" slot-scope="props">
              <strong>{{ props.option.id }}</strong> - {{ props.option.name }}
            </template>
          </Multiselect>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-secondary" @click.prevent="setPut()">Alterar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>